import { ThemeEvents } from '@theme/events';

/**
 * Le sélecteur de variante récupère déjà la page du nouveau variant et la
 * diffuse dans `variant:updated`. Il ne re-rend que son propre markup : chaque
 * composant va chercher son fragment dans ce document, comme product-inventory.
 * Sans cet écouteur, le plan de composition restait figé sur la configuration
 * chargée au départ.
 */
class SeloriaComposition extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdated, this.updateComposition);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdated, this.updateComposition);
  }

  updateComposition = (event) => {
    const incoming = event.detail?.data?.html?.querySelector(
      'seloria-composition [data-ref="seloria-composition"]'
    );
    const current = this.querySelector('[data-ref="seloria-composition"]');

    if (!incoming || !current) return;

    if (current.innerHTML !== incoming.innerHTML) {
      current.replaceWith(incoming);
    }
  };
}

if (!customElements.get('seloria-composition')) {
  customElements.define('seloria-composition', SeloriaComposition);
}
